import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import {
  ANY_SPORT_COMMON_MARKET_ADD_CARD,
  ANY_SPORT_COMMON_MARKET_DROP_CARD,
} from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { commonMarketplace } from '@sorare/core/src/lib/glossary';

import { CommonMarketOnboarding } from '../CommonMarketOnboarding';
import { CommonMarketStatus } from '../CommonMarketStatus';

const Root = styled(FullWidthContainer)`
  padding-top: var(--unit);
  padding-bottom: var(--unit);
  background-color: var(--c-neutral-300);
`;

const Row = styled(Horizontal)`
  justify-content: space-between;
`;

const ButtonWrap = styled(Horizontal)`
  padding: var(--half-unit);
  border-radius: var(--triple-unit);
  background-color: var(--c-neutral-400);
`;

export const CommonMarketHeader = () => {
  const location = useLocation();
  const { generateSportContextPath, matchAnySportPath } = useSportContext();

  const addingCard = matchAnySportPath(
    ANY_SPORT_COMMON_MARKET_ADD_CARD,
    location.pathname
  );
  const droppingCard = matchAnySportPath(
    ANY_SPORT_COMMON_MARKET_DROP_CARD,
    location.pathname
  );

  return (
    <>
      <CommonMarketOnboarding />
      <OnboardingHighlightWrapper highlightName="CommonMarketHeader">
        <Root>
          <Row>
            <CommonMarketStatus />
            <ButtonWrap>
              <Button
                size="small"
                to={generateSportContextPath(ANY_SPORT_COMMON_MARKET_ADD_CARD)}
                color={addingCard ? 'secondary' : 'transparent'}
              >
                <FormattedMessage {...commonMarketplace.add} />
              </Button>
              <Button
                size="small"
                to={generateSportContextPath(ANY_SPORT_COMMON_MARKET_DROP_CARD)}
                color={droppingCard ? 'secondary' : 'transparent'}
              >
                <FormattedMessage {...commonMarketplace.drop} />
              </Button>
            </ButtonWrap>
          </Row>
        </Root>
      </OnboardingHighlightWrapper>
    </>
  );
};
